
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Die am häufigsten zitierte <Link icon='file pdf outline' href='https://www.medrxiv.org/content/10.1101/2020.03.09.20033217v1.full.pdf' mdxType="Link">Studie</Link> zum Thema, jene des US-Gesundheitsinstituts
  NIH, fand heraus, dass Sars-CoV-2 auf Kunststoff und Edelstahl bis zu 72
  Stunden überleben kann. Auf Karton und Papier dagegen überlebte das Virus nur
  bis zu 24 Stunden. Das heisst, dass solange noch lebensfähige Viren
  nachweisbar waren, ihre Menge sich aber deutlich reduziert hatte. In der Luft
  sind die Viren dagegen als Partikel (Aerosole) bereits nach etwa drei Stunden
  nicht mehr nachweisbar. Die US-Studie konnte nicht klären, ob und mit welcher
  Wahrscheinlichkeit man sich aufgrund aktiver Viren auf Oberflächen oder in der
  Luft infizieren kann. Es kommt auch darauf an, wie viele Viren an einer Stelle
  aufgenommen werden, also wie gross die Virenkonzentration etwa an der
  Türklinke ist. Wie viele das für eine Ansteckung sein müssten, ist noch nicht
  bekannt. Das Gute: Die Viren sind sehr einfach und innerhalb einer Minute mit
  Desinfektionsmitteln oder Seife zu zerstören.
    </p>
    <Image className='cbImage' file={require("images/illus_surfaces.jpg")} mdxType="Image" />
    <p>
  In einer anderen Studie wurden noch längere Überlebenszeiten auf Oberflächen
  festgestellt. Auf Glas, Edelstahl und glatten Kunststoffoberflächen kann das
  neue Coronavirus offenbar bis zu 28 Tage überleben und dabei infektiös
  bleiben. Das haben Wissenschaftler vom Australian Center for Disease
  Preparedness in der Fachzeitschrift <Link href='https://virologyj.biomedcentral.com/articles/10.1186/s12985-020-01418-7' allowWordWrap mdxType="Link">«Virology Journal»</Link> dargelegt. Die
  Experimente der Studie wurden allerdings im Dunkeln durchgeführt. Sonnenlicht
  könne das Virus schnell abtöten, schreiben die Forscher.
    </p>
    <p>
  Dennoch scheinen Oberflächen bei der Übertragung offenbar nur eine
  untergeordnete Rolle zu spielen. Es gibt weltweit bislang kaum Fälle, bei
  denen nachgewiesen wurde, dass das Coronavirus über diesen Weg auf Menschen
  übertragen wurde.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;